module.exports = __webpack_public_path__ + "img/ip.2181c226.svg";